import * as R from "ramda";
import moment from "moment";

// export const showNotification = (title, text) => {
//   const btn = (
//     <Button
//       onClick={() => {
//         notification.close();
//       }}
//       type="primary"
//       size="small"
//     >
//       Upgrade Plan
//     </Button>
//   );
//   notification.config({
//     duration: 10,
//     placement: "bottomLeft"
//   });
//   const args = {
//     message: title,
//     description: text,
//     btn
//   };
//   notification.warn(args);
// };

const eqValues = R.compose(R.isEmpty, R.symmetricDifference);

export const checkProbersViolation = (probers, activePlanProbers) =>
  !eqValues(probers, activePlanProbers);

export const checkProtocolViolation = (protocol, activePlanProtocols) =>
  !R.includes(protocol, activePlanProtocols);

export const checkMethodViolation = (method, activePlanMethods) =>
  !R.includes(method, activePlanMethods);

export const checkMetricHistoryViolation = (
  date,
  activePlanMetricHistory,
  isShare
) => {
  if (date) {
    if (isShare) {
      return false;
    }
    const historyDate = moment(date);
    const today = moment();
    const lastExistingHistory = today.subtract(activePlanMetricHistory, "days");
    const isBeforeValidHistory = historyDate.isBefore(lastExistingHistory);
    return isBeforeValidHistory;
  }
  return false;
};

export const checkNotificationLimitViolation = (
  notification,
  activePlanNotification
) => {};

export const checkAlertChanelLimitViolation = (
  alertChanel,
  activePlanAlertChanel
) => {};

export const checkMaxMonitorCountViolation = (
  monitorCount,
  activePlanMonitorCount
) => monitorCount < activePlanMonitorCount;

export const checkMinMonitorPeriodViolation = (
  period,
  activePlanMinMonitorPeriod
) => period < activePlanMinMonitorPeriod;

// {
//   "PROBERS": [
//     2,
//     1,
//     7,
//     14
//   ],
//   "PROTOCOL": {
//     "HTTP": {
//       "AVAILABLE_METHODS": [
//         "GET",
//         "HEAD"
//       ]
//     }
//   },
//   "METRIC_HISTORY_DAYS": 186,
//   "NOTIFICATION_LIMITS": {
//     "sms": {
//       "maximum": 5
//     },
//     "email": {
//       "maximum": 50
//     },
//     "phone": {
//       "maximum": 1
//     },
//     "slack": {
//       "maximum": 0
//     },
//     "webhook": {
//       "maximum": 0
//     },
//     "telegram": {
//       "maximum": 100
//     }
//   },
//   "ALERT_CHANNEL_LIMITS": {
//     "email": {
//       "maximum": 1
//     },
//     "phone": {
//       "maximum": 1
//     },
//     "slack": {
//       "maximum": 0
//     },
//     "webhook": {
//       "maximum": 0
//     },
//     "telegram_username": {
//       "maximum": 1
//     }
//   },
//   "MAXIMUM_MONITOR_COUNT": 2,
//   "MINIMUM_MONITOR_PERIOD": 300,
//   "ALERT_NOTIFICATION_STRATEGIES": [
//     "email",
//     "telegram",
//     "phone",
//     "sms",
//     "webhook",
//     "all",
//     "escalating"
//   ]
// }
